import React from 'react';
import styled, { css } from 'styled-components';
import { mediaQuery } from '../theme';

export type IconProps = React.HTMLAttributes<SVGElement> & {
  className?: string;
  xmlns?: string;
  width?: string | number;
  height?: string | number;
  viewBox?: string;
  color?: string;
  fill?: string;
  enableBackground?: string;
};

export const Icon: React.FC<IconProps> = ({ children, ...props }) => (
  <Container {...props}>{children}</Container>
);

const Container = styled.svg<{
  width?: string | number;
  mediuMediaSize?: string | number;
  height?: string | number;
  fill?: string;
}>(
  ({ width, height, fill }) => css`
    display: flex;
    fill: ${fill || 'currentColor'};
    width: ${width ? `${Number(width) / 16}em` : '100%'};
    height: ${height ? `${Number(height) / 16}em` : '100%'};
    @media ${mediaQuery.medium} {
      width: ${(mediumMediaSize) =>
        mediumMediaSize
          ? `${Number(mediumMediaSize) / 16}em`
          : width
            ? `${Number(width) / 16}em`
            : '100%'};
      height: ${(mediumMediaSize) =>
        mediumMediaSize
          ? `${Number(mediumMediaSize) / 16}em`
          : height
            ? `${Number(height) / 16}em`
            : '100%'};
    }
  `
);
